import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import Person2Icon from "@mui/icons-material/Person2";
import { Outlet, Link, useLocation } from "react-router-dom";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import translateText, { currentLanguage } from "../signals/language.signal";
import { primary } from "../signals/Theme colors.signal";
import { signalPagePath } from "../signals/login.signal";
import hasJWT from "../helpers/hasJWT";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import SideBar from "../components/sideBar";
import InfoIcon from "@mui/icons-material/Info";
import StyleIcon from "@mui/icons-material/Style";
const More = () => {
  const location = useLocation();

  const isActive = (path) => {
    hasJWT();
    return location.pathname === path
      ? { fill: primary.value, color: primary.value }
      : {};
  };

  return (
    <>
      <SideBar
        more={true}
        showAccount={true}
        title={translateText(currentLanguage.value, "More")}
      />
      <div className="p-3">
        <Link to={signalPagePath.value ? "/Catalog" : "/"}>
          <div className="d-flex justify-content-between shadow-sm p-2  flex-row w-100 align-items-center">
            <div className="d-flex align-items-center ">
              <StyleIcon
                sx={{
                  cursor: "pointer",
                  fill: "#afaeae",
                  fontSize: 28,
                }}
                className="me-3 ms-3"
              />
              <p
                style={{
                  cursor: "pointer",
                  color: "#afaeae",
                  fontSize: "14px",
                  margin: "0",
                }}
              >
                {translateText(currentLanguage.value, "Catalogs")}
              </p>
            </div>
            <ArrowForwardIosIcon
              sx={{
                cursor: "pointer",
                fill: "#afaeae",
                fontSize: 20,
              }}
            />
          </div>
        </Link>
        <Link
          to={signalPagePath.value ? "/noteRate" : "/"}
          onClick={() => window.scrollTo(0, 0)}
        >
          <div className="d-flex justify-content-between shadow-sm p-2  flex-row w-100 align-items-center">
            <div className="d-flex align-items-center ">
              <SpeakerNotesIcon
                sx={{
                  cursor: "pointer",
                  fill: "#afaeae",
                  fontSize: 28,
                }}
                className="me-3 ms-3"
              />
              <p
                style={{
                  cursor: "pointer",
                  color: "#afaeae",
                  fontSize: "14px",
                  margin: "0",
                }}
              >
                {translateText(currentLanguage.value, "NoteRateTitle")}
              </p>
            </div>
            <ArrowForwardIosIcon
              style={isActive("/noteRate")}
              sx={{
                cursor: "pointer",
                fill: "#afaeae",
                fontSize: 20,
              }}
            />
          </div>
        </Link>
        <Link
          to={signalPagePath.value ? "/profile" : "/"}
          onClick={() => window.scrollTo(0, 0)}
        >
          <div className="d-flex justify-content-between shadow-sm p-2  flex-row w-100 align-items-center">
            <div className="d-flex align-items-center ">
              <Person2Icon
                sx={{
                  cursor: "pointer",
                  fill: "#afaeae",
                  fontSize: 28,
                }}
                className="me-3 ms-3"
              />
              <p
                style={{
                  cursor: "pointer",
                  color: "#afaeae",
                  fontSize: "14px",
                  margin: "0",
                }}
              >
                {translateText(currentLanguage.value, "Profile")}
              </p>
            </div>
            <ArrowForwardIosIcon
              style={isActive("/offer")}
              sx={{
                cursor: "pointer",
                fill: "#afaeae",
                fontSize: 20,
              }}
            />
          </div>
        </Link>
        <Link
          to={signalPagePath.value ? "/TermsAndConditions" : "/"}
          onClick={() => window.scrollTo(0, 0)}
        >
          <div className="d-flex justify-content-between shadow-sm p-2  flex-row w-100 align-items-center">
            <div className="d-flex align-items-center ">
              <ArticleOutlinedIcon
                sx={{
                  cursor: "pointer",
                  fill: "#afaeae",
                  fontSize: 28,
                }}
                className="me-3 ms-3"
              />
              <p
                style={{
                  cursor: "pointer",
                  color: "#afaeae",
                  fontSize: "14px",
                  margin: "0",
                }}
              >
                {translateText(currentLanguage.value, "TermsAndConditions")}
              </p>
            </div>
            <ArrowForwardIosIcon
              style={isActive("/TermsAndConditions")}
              sx={{
                cursor: "pointer",
                fill: "#afaeae",
                fontSize: 20,
              }}
            />
          </div>
        </Link>
        <Link
          to={signalPagePath.value ? "/AboutUs" : "/"}
          onClick={() => window.scrollTo(0, 0)}
        >
          <div className="d-flex justify-content-between shadow-sm p-2  flex-row w-100 align-items-center">
            <div className="d-flex align-items-center ">
              <InfoIcon
                sx={{
                  cursor: "pointer",
                  fill: "#afaeae",
                  fontSize: 28,
                }}
                className="me-3 ms-3"
              />
              <p
                style={{
                  cursor: "pointer",
                  color: "#afaeae",
                  fontSize: "14px",
                  margin: "0",
                }}
              >
                {translateText(currentLanguage.value, "AboutUsTitle")}
              </p>
            </div>
            <ArrowForwardIosIcon
              style={isActive("/AboutUs")}
              sx={{
                cursor: "pointer",
                fill: "#afaeae",
                fontSize: 20,
              }}
            />
          </div>
        </Link>
        <Outlet />
      </div>
    </>
  );
};
export default More;
